export default function StaffDisplay({ config }) {
  return (
    <div style={{ 
      border: "1px solid #ccc",
      padding: "20px",
      marginTop: "10px",
      textAlign: "center"
    }}>
      STAFF DISPLAY (notation: {config.notation})
    </div>
  );
}
